import { render, staticRenderFns } from "./Banner4.vue?vue&type=template&id=78643f2a"
import script from "./Banner4.vue?vue&type=script&lang=js"
export * from "./Banner4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports